<template>
  <div class="bl">
  	<div class="bl__bg">
    	<Tabs :tabs="['Блоки', 'Слои', 'Инспектор']" v-model="currentTab" />

      <div v-show="currentTab == 'Блоки'" class="bl__folders">
        <FoldersList :folderCategory="componentsList"/>
      </div>
      <div v-show="currentTab == 'Слои'" class="bl__tree-nodes">
        <TreeAccordion :items="landingData"/>
      </div>
      <div v-show="currentTab == 'Инспектор'">
        <Inspector/>
      </div>
      

    </div>
  </div>
</template>

<script>
import Tabs from "@/components/UI/Pagination/Tabs.vue"
import Multiselect from "@/components/UI/Select/Multiselect.vue"
import FoldersList from "@/components/UI/Folders/FoldersList.vue"
import TreeAccordion from "@/components/UI/Folders/TreeList/TreeAccordion.vue"
import Inspector from "@/components/pages/inspector/index.vue"

export default {
  components: {
    Tabs, Multiselect, FoldersList, TreeAccordion, Inspector
  },
  data() {
    return {
      currentTab: 'Блоки',
      selectedItems: '',
      options: ['Домашняя', 'of', 'options'],
    };
  },
  computed: {
    componentsList () {
      return this.$store.state.components.list
    },
    landingData() {
      return this.$store.getters['landing/landingData'] || []
    },
  }
};
</script>



<style scoped>
.bl {
	position: fixed;
	width: 100%;
  height: 100%;
  top: 3rem;
  left: 0;
  overflow: hidden;
  max-height: 100%;
}
.bl__bg {
  min-height: 100%;
  background-color: var(--grey-2);
  padding: 1rem;
  border: 1px solid var(--grey-1);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
	gap: 1rem;
  max-width: 305px;
  overflow: hidden;
  height: 100%;
  padding-bottom: 5rem;
}

.bl__folders, .bl__tree-nodes {
  height: 100%;
}

@media (max-width: 1350px) {
  .bl__bg {
    max-width: 20.5rem;
  }
}


@media (max-width: 768px) {
  .bl {
    display: none;
  }
}

</style>






